import React, { useState, useEffect, useContext, useReducer } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../../components/MaterialButton";
import colors from "../../../assest/theme/base/colors";
import {
  Autocomplete,
  Box,
  Chip,
  Dialog,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import DynamicTableProps from "../../Utils/DynamicTableProps";
import AddShortlist from "./addshortlist";
import ConfirmDialog from "../../Utils/ConfirmDialog";
import {
  getalluserdetailstatus,
  deleteuserstatus,
  getallShortlistFilter,
  getallShortlistByHrUser,
  searchShortlist,
} from "../shortlisted/mutation";
import { fetchAll, deleteItem, postItem, fetchById, FetchDataGet } from "../../../BaseUrl";
import MessagePopup from "../../Utils/MessagePopup";
import LoadingSpinner from "../../loader/loadercomp";
import AccessComponent from "../../Utils/AccessComponent";
import { UserContext } from "../../usercontext/usercontext";
import { filterInitialState, filterReducer } from "../../Utils/FilterReducer";
import ReusableFilter from "../../Utils/ReusableFilter";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../components/MaterialTypography";
import OptionConvert from "../../Utils/OptionConvert";
import ExportDialog from "../../Utils/ExportDialog";
import {
  Getalluserdetail,
  getByTLUserdetail,
  GetalluserdetailDropdown
} from "../../Masters/UserMaster/mutation";
import { GETCLIENT } from "../../Masters/ClientMaster/Mutation";
import {GETCLIENTDROPDOWN} from '../../Masters/PositionMaster/mutation'
import RestartAltIcon from "@mui/icons-material/RestartAlt";

function Shortlist() {
  const { user, isuser } = useContext(UserContext);
  const [filterState, dispatch] = useReducer(filterReducer, filterInitialState);
  const [openFilter, setOpenFilter] = useState(false);
  const [open, setOpen] = useState(false);
  const [view, setview] = useState(false);
  const [openExport, setOpenExport] = useState(false);
  const [searchdata, setsearchdata] = useState("");
  const [sortedvalue, setsortedvalue] = useState("");
  const [editeddata, setEditeddata] = useState([]);
  const [editedtrue, setEditedtrue] = useState(false);
  const [dialogData, setDialogData] = useState({
    title: "",
    content: "",
    onConfirm: () => { },
  });
  const [Loader, setLoader] = useState(false);
  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [userlist, setuserlist] = useState([]);
  const [isFilter, setIsFilter] = useState(false);
  const [fileterdownloadurl, setFileterdownloadurl] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [clientOptions, setClientOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);

  console.log("clientOptions",clientOptions)

  // Pagination state
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const columns = [
    { label: "shortlisted Date", field: "shortlistedDate", width: "100px" },
    { label: "Name", field: "candidateName", width: "100px" },
    { label: "Contact Number", field: "candidateNumber", width: "100px" },
    { label: "Client", field: "clientName", width: "100px" },
    { label: "Position", field: "positionName", width: "100px" },
    { label: "Interview Date", field: "interviewDate", width: "100px" },
    { label: "HR Name", field: "createdBy", width: "100px" },
    { label: "Status", field: "status", width: "95px" },
    { label: "Feedback", field: "shortlistFeedback", width: "100px" },
    { label: "Actions", field: "actions", width: "125px" },
  ];

  const validIndustryData = Array.isArray(userlist) ? userlist : [];

  const sortedData = [...validIndustryData].sort((a, b) => {
    const sortOption = sortedvalue?.value || "descending"; // default to descending
    switch (sortOption) {
      case "ascending":
        return new Date(a.createdAt) - new Date(b.createdAt);
      case "descending":
        return new Date(b.createdAt) - new Date(a.createdAt);
      default:
        return validIndustryData; // default to descending
    }
  });

  const exportData = sortedData.map((item) => ({
    shortlistedDate: item.shortlistedDate
      ? item.shortlistedDate
      : item.shortlistedDate,
    candidateName: item.candidateName || "",
    contactNumber: item.candidateNumber || "",
    client: item.clientName || "",
    position: item.positionName || "",
    interviewDate: item.interviewDate ? item.interviewDate : item.interviewDate,
    hrName: item.createdBy || "",
    status: item.status || "",
    shortlistFeedback: item.shortlistFeedback || "",
    createdAt: item.createdAt || "",
    updatedAt: item.updatedAt || "",
  }));

  const fetchCurrentData = () => {
    if (isFilter) {
      filterSubmit();
    } else {
      getAllShortlistData();
    }
  };

  useEffect(() => {
    getUser();
    getClientData();
  }, []);

  useEffect(() => {
    if (!open) {
      const delayDebounceFn = setTimeout(() => {
        fetchCurrentData();
      }, 1000);

      return () => clearTimeout(delayDebounceFn);
    }
  }, [page, pageSize, open, searchdata]);

  useEffect(() => {
    setPage(1);
  }, [searchdata]);

  const formClose = () => {
    setOpen(false);
    setview(false);
    setEditedtrue(false);
  };

  const handleResetFilter = () => {
    setIsFilter(false);
    dispatch({ name: "reset" });
    if (page === 1) {
      getAllShortlistData();
    } else {
      setPage(1);
    }
  };

  const filterClose = () => {
    setOpenFilter(false);
  };
  const addRole = () => {
    setOpen(true);
  };

  const onView = (id) => {
    let data = userlist.filter((x) => x.id === id);
    setEditeddata(data);
    setOpen(true);
    setview(true);
  };

  const onEdit = (id) => {
    let data = userlist.filter((x) => x.id === id);
    setEditeddata(data);
    setEditedtrue(true);
    setOpen(true);
  };

  const deletelist = (id) => {
    handleOpenDialog();
    setDialogData({
      title: "Are you sure you want to delete this records ?",
      content: `If you delete the field you can’t recover it`,
      onConfirm: () => deleteconfirm(id),
      onClose: () => deletecancel(),
    });
  };

  const formatDate = (isoDate) => {
    const [year, month, day] = isoDate.split("-");
    return `${day}-${month}-${year}`;
  };

  const deleteconfirm = async (id) => {
    try {
      const variables = {
        input: {
          id: id,
        },
      };
      const response = await deleteItem(deleteuserstatus, variables);
      if (response.deleteScreening.success === true) {
        setPopup({
          open: true,
          message: response.deleteScreening.message,
          severity: "success",
        });
      } else {
        setPopup({
          open: true,
          message: response.deleteScreening.message,
          severity: "error",
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      deletecancel();
      fetchCurrentData();
    }
  };

  const deletecancel = () => {
    setDialogOpen(false);
    setDialogData({
      ...dialogData,
      title: "",
      content: "",
      onConfirm: () => { },
    });
  };

  //open and close dialog for confirmation
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const getAllShortlistData = async () => {
    setLoader(true);
    try {
      if (searchdata && searchdata.length > 2) {
          const payload = {
          search: searchdata,
          page,
          pageSize,
          ...(user.roleName !== "Admin" && {
            hrUserId: parseInt(isuser.userid),
          }),
        };
        const response = await FetchDataGet(searchShortlist, payload);
        if (response?.searchScreenedCandidates?.success === true) {
          const RowsData = response?.searchScreenedCandidates?.screening.map((item) => ({
            id: item.id || "",
            shortlistedDate: item.shortlistedDate
              ? formatDate(item.shortlistedDate)
              : item.shortlistedDate,
            candidateName: item.candidateName || "",
            candidateNumber: item.candidateNumber || "",
            status: item.status || "",
            positionName: item.position?.positionName || "",
            positionId: item.position?.id || "",
            interviewDate: item?.interviewDate
              ? formatDate(item?.interviewDate)
              : item?.interviewDate,
            clientName: item.client?.clientName || "",
            clientId: item.client?.id || "",
            shortlistFeedback: item.shortlistFeedback || "",
            createdBy: item.createdBy || "",
            createdAt: item.createdAt || "",
            updatedAt: item.updatedAt || "",
          }));
          setuserlist(RowsData);
          setTotalCount(response?.searchScreenedCandidates?.totalCount || 0);
        } else {
          setuserlist([]);
        }
      } else {
        if (user.roleName === "Admin") {
          const response = await FetchDataGet(getalluserdetailstatus, { page, pageSize });
          if (response?.getAllScreened?.success === true) {
            const RowsData = response?.getAllScreened?.screening.map((item) => ({
              id: item.id || "",
              shortlistedDate: item.shortlistedDate
                ? formatDate(item.shortlistedDate)
                : item.shortlistedDate,
              candidateName: item.candidateName || "",
              candidateNumber: item.candidateNumber || "",
              status: item.status || "",
              positionName: item.position.positionName || "",
              positionId: item.position?.id || "",
              interviewDate: item?.interviewDate
                ? formatDate(item?.interviewDate)
                : item?.interviewDate,
              clientName: item.client.clientName || "",
              clientId: item.client.id || "",
              shortlistFeedback: item.shortlistFeedback || "",
              createdBy: item.createdBy || "",
              createdAt: item.createdAt || "",
              updatedAt: item.updatedAt || "",
            }));
            setuserlist(RowsData);
            setTotalCount(response?.getAllScreened?.totalCount || 0);
          } else {
            setuserlist([]);
          }
        } else {
          const variables = {
            hrUserId: parseInt(isuser.userid),
            page,
            pageSize
          };
          const response = await postItem(getallShortlistByHrUser, variables);
          if (response?.getAllScreened?.success === true) {
            const RowsData = response?.getAllScreened?.screening.map((item) => ({
              id: item.id || "",
              shortlistedDate: item.shortlistedDate
                ? formatDate(item.shortlistedDate)
                : item.shortlistedDate,
              candidateName: item.candidateName || "",
              candidateNumber: item.candidateNumber || "",
              status: item.status || "",
              positionName: item.position.positionName || "",
              interviewDate: item?.interviewDate
                ? formatDate(item?.interviewDate)
                : item?.interviewDate,
              positionId: item.position?.id || "",
              clientName: item.client.clientName || "",
              clientId: item.client.id || "",
              shortlistFeedback: item.shortlistFeedback || "",
              createdBy: item.createdBy || "",
              createdAt: item.createdAt || "",
              updatedAt: item.updatedAt || "",
            }));
            setuserlist(RowsData);
            setTotalCount(response?.getAllScreened?.totalCount || 0);
          } else {
            setuserlist([]);
          }
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
      setIsFilter(false);
      dispatch({ name: "reset" });
    }
  };

  const getUser = async () => {
    setLoader(true);
    const role = user?.roleName;
    const userId = parseInt(isuser?.userid);

    try {
      if ((role === "Team Lead" || role === "Team Leader") && userId) {
        const variables = { id: userId };

        const response = await fetchById(getByTLUserdetail, variables);
        if (response?.getTeamLeaderUserById?.success === true) {
          const data = response?.getTeamLeaderUserById.data;
          const userData = OptionConvert(data, "username", "id");
          setUserOptions(userData);
        } else {
          setuserlist([]);
        }
      } else {
      const variables = {
        search: '',
        page: 0,
        pageSize:0,
      };
        const response = await FetchDataGet(GetalluserdetailDropdown,variables);
        if (response?.getAllCustomUserDetails?.success === true) {
          const data = response?.getAllCustomUserDetails.data;
          const userData = OptionConvert(data, "username", "id");
          setUserOptions(userData);
        } else {
          setuserlist([]);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const getClientData = async () => {
    try {
       const variables = {
        search: '',
        page: 0,
        pageSize:0,
      };
      const response = await FetchDataGet(GETCLIENTDROPDOWN,variables);
      if (response?.getAllClients?.success === true) {
        const data = response?.getAllClients?.data.map((v, i) => ({
          value: v?.id,
          label: v?.clientName,
          address: v?.address,
          mapLocation: v?.mapLocation,
          contactperson: v?.primaryContactPerson,
        }));

        if (user?.roleName === "Admin" || user?.roleName === "Consultant") {
          console.log("data",data)
          setClientOptions(data);
        } else {
          const res = await FetchDataGet(GetalluserdetailDropdown,variables);
          if (res?.getAllCustomUserDetails?.success === true) {
            let filteredIsUsers = [];
            const userDetails = res.getAllCustomUserDetails.data;

            filteredIsUsers = userDetails.find(
              (item) => item.id === String(isuser.userid)
            );

            let client = filteredIsUsers.clientHandling.map(
              (value) => value.id
            );

            let filteredData = client.map((client) =>
              data.find((item) => item.value == client)
            );

            setClientOptions(filteredData);
          } else {
            setClientOptions([]);
          }
        }
      } else {
        setClientOptions([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const filterSubmit = async () => {
    setLoader(true);

    try {
      const isPrivileged = ["Admin"].includes(user?.roleName);

      const hrUserIds =
        filterState?.user?.length > 0
          ? filterState.user.map((u) => u?.value)
          : isPrivileged
            ? []
            : [parseInt(isuser?.userid)];

      const clientIds =
        filterState?.client.length > 0
          ? filterState?.client?.map((c) => c?.value)
          : [];

      const filters = {
        hrUserIds: hrUserIds || [parseInt(isuser?.userid)],
        clientIds: clientIds,
        statusList: ["shortlisted", "not_shortlisted"],
        dateFrom: filterState?.fromDate,
        dateTo: filterState?.toDate,
      };

      const response = await postItem(getallShortlistFilter, {
        filters,
        page,
        pageSize
      });
      if (response?.exportFilteredScreenings?.success === true) {
        setFileterdownloadurl(response?.exportFilteredScreenings?.downloadUrl)
        const RowsData = response?.exportFilteredScreenings?.screening?.map(
          (item) => ({
            id: item?.id || "",
            shortlistedDate: item?.shortlistedDate
              ? formatDate(item?.shortlistedDate)
              : item?.shortlistedDate,
            candidateName: item?.candidateName || "",
            candidateNumber: item?.candidateNumber || "",
            status: item?.status || "",
            interviewDate: item?.interviewDate
              ? formatDate(item?.interviewDate)
              : item?.interviewDate,
            positionName: item?.position?.positionName || "",
            positionId: item?.position?.id || "",
            clientName: item?.client?.clientName || "",
            clientId: item?.client.id || "",
            shortlistFeedback: item?.shortlistFeedback || "",
            createdBy: item?.createdBy || "",
            createdAt: item?.createdAt || "",
            updatedAt: item?.updatedAt || "",
          })
        );
        setuserlist(RowsData);
        setTotalCount(response?.exportFilteredScreenings?.totalCount || 0);
      } else {
        setuserlist([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
      setIsFilter(true);
    }
  };

  const exportClose = () => {
    setOpenExport(false);
  };

  return (
    <DashboardLayout
      searchdata={searchdata}
      setsearchdata={setsearchdata}
      setOpenFilter={setOpenFilter}
      setOpenExport={setOpenExport}
      name={sortedData.length > 0 ? "Shortlisted" : ""}
    >
      {Loader && <LoadingSpinner />}
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      <ConfirmDialog
        open={dialogOpen}
        title={dialogData.title}
        content={dialogData.content}
        onClose={handleCloseDialog}
        onConfirm={dialogData.onConfirm}
      />
      <ExportDialog
        open={openExport}
        onClose={exportClose}
        setPopup={setPopup}
        data={exportData}
        fileName="Shortlist"
        exportStatus="shortlist"
        isFilter={isFilter}
        fileterdownloadurl={fileterdownloadurl}
      />
      <ReusableFilter
        data={filterState}
        dispatch={dispatch}
        open={openFilter}
        onClose={filterClose}
        onSave={() => {
          setIsFilter(true);
          if (page === 1) {
            filterSubmit();
          } else {
            setPage(1);
          }
          filterClose();
        }}
        title="Shortlist Filter"
      >
        {/* 👇 Client Autocomplete */}
        <Grid size={{ xs: 12, sm: 6 }}>
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Client
          </MaterialTypography>
          <Autocomplete
            multiple
            options={clientOptions || []}
            getOptionLabel={(option) => option.label || ""}
            value={filterState?.client || []}
            onChange={(event, newValue) =>
              dispatch({ name: "client", value: newValue })
            }
            filterSelectedOptions
            renderTags={(selected, getTagProps) =>
              (selected || []).map((option, index) => (
                <Chip
                  key={index}
                  label={option.label}
                  {...getTagProps({ index })}
                />
              ))
            }
            renderInput={(params) => (
              <TextField {...params} placeholder="Select Client(s)" />
            )}
          />
        </Grid>

        {/* 👇 User Autocomplete */}
        {(user?.roleName === "Admin" ||
          user?.roleName === "Team Lead" ||
          user?.roleName === "Team Leader") && (
            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                User
              </MaterialTypography>
              <Autocomplete
                multiple
                options={userOptions || []}
                getOptionLabel={(option) => option.label || ""}
                value={filterState?.user || []}
                onChange={(event, newValue) =>
                  dispatch({ name: "user", value: newValue })
                }
                filterSelectedOptions
                renderTags={(selected, getTagProps) =>
                  (selected || []).map((option, index) => (
                    <Chip
                      key={index}
                      label={option.label}
                      {...getTagProps({ index })}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select User(s)" />
                )}
              />
            </Grid>
          )}
      </ReusableFilter>
      <Dialog
        open={open}
        sx={{
          "& .MuiDialog-paper": {
            width: "800px", // Set your desired width
            maxWidth: "none", // Prevent it from limiting the width to default sizes
          },
        }}
      >
        <AddShortlist
          formClose={formClose}
          editeddata={editeddata}
          editedtrue={editedtrue}
          setEditedtrue={setEditedtrue}
          view={view}
        />
      </Dialog>
      <Box sx={{ display: "flex", justifyContent: "flex-end", width: "98%" }}>
        {isFilter && (
          <Tooltip title="Reset Filter" placement="top">
            <IconButton
              onClick={handleResetFilter}
              sx={{ fontSize: "25px", background: colors.buttonColor, mr: 1 }}
            >
              <RestartAltIcon sx={{ color: "#fff" }} />
            </IconButton>
          </Tooltip>
        )}
        <AccessComponent name="Shortlisted" action="Create">
          <MaterialButton
            variant="contained"
            onClick={() => {
              addRole();
            }}
            sx={{
              background: colors.buttonColor,
              color: "#fff",
              textTransform: "capitalize",
            }}
          >
            + Add Shortlist
          </MaterialButton>
        </AccessComponent>
      </Box>
      <DynamicTableProps
        columns={columns}
        rows={sortedData}
        onView={onView}
        onEdit={onEdit}
        onDelete={deletelist}
        name="Shortlisted"
        serverPage={page}
        totalCount={totalCount}
        rowsPerPage={pageSize}
        onPageChange={(event, newPage) => setPage(newPage)}
        ischeck={false}
      />
    </DashboardLayout>
  );
}

export default Shortlist;
